import { TypeBadge, StatusBadge, ReliabilityBadge, ProposalBadge } from "@/components/Badges";
import { gmapsUrl, gmapsViewUrl, formatTime } from "@/lib/events";
import { Navigation, ShieldAlert, MapPin } from "lucide-react";

export default function EventCard({ event, onOpen }) {
  return (
    <div data-testid={`event-card-${event.id}`} onClick={() => onOpen(event)} role="button" tabIndex={0}
      onKeyDown={(e) => { if (e.key === "Enter") onOpen(event); }}
      className="bg-[#151C28] border border-slate-800 rounded-xl p-4 shadow-lg shadow-black/30 cursor-pointer hover:border-slate-600 transition-colors">
      <div className="flex flex-wrap items-center gap-2 justify-between">
        <div className="flex flex-wrap gap-2">
          <TypeBadge type={event.type} />
          <StatusBadge status={event.status} />
        </div>
        {event.distance_km != null && (
          <span className="text-xs font-bold text-sky-400 font-mono">{event.distance_km} km</span>
        )}
      </div>
      <div className="text-left w-full mt-3">
        <h3 className="text-base font-bold text-slate-50 leading-snug">{event.title}</h3>
        <p className="text-xs text-slate-400 flex items-center gap-1 mt-1">
          <MapPin size={12} /> {event.city}{event.department ? ` · ${event.department}` : ""}
        </p>
      </div>
      <div className="flex items-center gap-2 mt-2 flex-wrap">
        <ReliabilityBadge reliability={event.reliability} />
        {event.is_proposal && <ProposalBadge count={event.proposal_count} />}
        <span className="text-[11px] text-slate-500">MàJ {formatTime(event.updated_at)}</span>
      </div>
      <div className="grid grid-cols-2 gap-2 mt-3">
        <a data-testid={`btn-sy-rendre-${event.id}`} href={gmapsUrl(event.lat, event.lng)} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}
          className="bg-blue-600 hover:bg-blue-500 active:scale-95 transition text-white font-bold py-2.5 rounded-lg flex items-center justify-center gap-1.5 text-xs">
          <Navigation size={14} /> S'y rendre
        </a>
        <a data-testid={`btn-eviter-zone-${event.id}`} href={gmapsViewUrl(event.lat, event.lng)} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}
          className="bg-red-600/90 hover:bg-red-500 active:scale-95 transition text-white font-bold py-2.5 rounded-lg flex items-center justify-center gap-1.5 text-xs">
          <ShieldAlert size={14} /> Éviter
        </a>
      </div>
    </div>
  );
}
